var portfolio = {
	addTransactionAction: "Aggiungi Transazione",
	topFlopTitle: "Posizione Top/Flop",
	breakdownsTitle: "Ripartizione di informazioni",
	assetClassBreakdownTitle: "Asset classes",
	currencyBreakdownTitle: "Valute",
	sectorBreakdownTitle: "Settori",
	sectorBreakdownSubtitle: "Ponderazione rispetto al portafoglio totale",
	evaluationChartTitle: "Valore del portafoglio",
	unrealizedPerformancePositionsTitle: "Performance non realizzate",
	weightPositionsTitle: "Ponderazione del portafoglio",
	editPortfolioAction: "Modifica Portafoglio",
	deletePortfolioAction: "Elimina Portafoglio",
	createPortfolioAction: "Crea Portafoglio",
	addPortfolioAction: "Crea Portafoglio",
	editTransactionAction: "Modifica Transazione",
	deleteTransactionAction: "Elimina Transazione",
	errorAlertLabel: "Si è verificato un errore",
	transactionLimitExceeded: "Superato il limite di transazione",
	portfolioLimitExceeded: "Superato il limite di portafoglio",
	info: "Informazioni",
	noPositionsAlert: "Il portafoglio non contiene alcuna posizione, aggiungi una transazione di acquisto",
	noTransactionsAlert: "Il portafoglio non contiene alcuna transazione, aggiungi una transazione di acquisto",
	noPortfolios: {
		title: "Info",
		message: "No portfolio has been created yet. Please click on the \"Add portfolio\" button and fill out the form to create a portfolio."
	},
	tab: {
		overview: "Panoramica",
		positions: "Posizioni",
		transactions: "Transazioni",
		news: "Notizie"
	},
	showActions: "Mostra azioni"
};
var it = {
	portfolio: portfolio
};

export { it as default, portfolio };
